import { createSelector } from 'reselect';
import { deliverySelector } from 'redux/modules/delivery';

export const tempUserAddressSelector = createSelector(
  deliverySelector,
  delivery => delivery.tempUserAddress,
);
